module.exports = __webpack_public_path__ + "img/avatar.eeeeb809.png";